// Live DOM localizer: translates rendered English UI text (exact phrase match against the central dictionary)
// so every screen follows the selected language without page reloads. User data marked translate="no" is never touched.
import { SW } from "@/i18n/sw";

const TXT = new WeakMap();
const ATT = new WeakMap();
const ATTRS = ["placeholder", "title", "aria-label"];
const SKIP = 'script,style,textarea,code,pre,[translate="no"],[data-no-i18n],[contenteditable="true"]';
const MON = { Jan: "Jan", Feb: "Feb", Mar: "Mac", Apr: "Apr", May: "Mei", Jun: "Jun", Jul: "Jul", Aug: "Ago", Sep: "Sep", Oct: "Okt", Nov: "Nov", Dec: "Des" };
const MONTHS = { January: "Januari", February: "Februari", March: "Machi", April: "Aprili", May: "Mei", June: "Juni", July: "Julai", August: "Agosti", September: "Septemba", October: "Oktoba", November: "Novemba", December: "Desemba" };
const n = (s) => SW[s] || s;
const PATTERNS = [
  [/^(\d+) overdue$/, (m) => `${m[1]} zimechelewa`],
  [/^(\d+) due soon$/, (m) => `${m[1]} zinakaribia tarehe ya mwisho`],
  [/^(\d+) tasks?$/, (m) => `kazi ${m[1]}`],
  [/^(\d+) documents?$/, (m) => `nyaraka ${m[1]}`],
  [/^(\d+) days? left$/, (m) => `zimebaki siku ${m[1]}`],
  [/^(\d+) days? overdue$/, (m) => `imechelewa siku ${m[1]}`],
  [/^Due in (\d+) days?$/, (m) => `Tarehe ya mwisho baada ya siku ${m[1]}`],
  [/^in (\d+) days?$/, (m) => `baada ya siku ${m[1]}`],
  [/^(\d+) days? ago$/, (m) => `siku ${m[1]} zilizopita`],
  [/^Page (\d+) of (\d+)$/, (m) => `Ukurasa ${m[1]} kati ya ${m[2]}`],
  [/^(\d+) selected$/, (m) => `${m[1]} zimechaguliwa`],
  [/^(\d+) results?$/, (m) => `matokeo ${m[1]}`],
  [/^Moved to (.+)$/, (m) => `Imehamishiwa: ${n(m[1])}`],
  [/^Issued (\S+)$/, (m) => `Imetolewa ${m[1]}`],
  [/^Recorded · (\S+)$/, (m) => `Imerekodiwa · ${m[1]}`],
  [/^Downloaded (\d+) (leads|tasks)$/, (m) => `Imepakuliwa ${m[1]} (${m[2] === "leads" ? "wateja watarajiwa" : "kazi"})`],
  [/^Closed for (\d+) staff$/, (m) => `Imefungwa kwa wafanyakazi ${m[1]}`],
  [/^Overdue \((\d+)\)$/, (m) => `Zilizochelewa (${m[1]})`],
  [/^Overdue (\d+)d$/, (m) => `Imechelewa siku ${m[1]}`],
  [/^(\d+)d overdue$/, (m) => `imechelewa siku ${m[1]}`],
  [/^Remarks & comments \((\d+)\)$/, (m) => `Maelezo na maoni (${m[1]})`],
  [/^To pay now \((\d+)\)$/, (m) => `Ya kulipa sasa (${m[1]})`],
  [/^Outstanding balance \((\d+)\):?$/, (m) => `Salio linalodaiwa (${m[1]})`],
  [/^Government fees · (\d+) open$/, (m) => `Ada za serikali · ${m[1]} wazi`],
  [/^(\d+) items? needs? your attention today\.$/, (m) => `Kipengele ${m[1]} kinahitaji uangalizi wako leo.`],
  [/^Issued (\d.+)$/, (m) => `Imetolewa ${m[1]}`],
  [/^paid (TZS .+)$/, (m) => `imelipwa ${m[1]}`],
  [/^\((\d+) working days?\)$/, (m) => `(siku ${m[1]} za kazi)`],
  [/^Late = first activity after (\S+)\. A full day is (\d+) hours\.$/, (m) => `Kuchelewa = shughuli ya kwanza baada ya saa ${m[1]}. Siku kamili ni saa ${m[2]}.`],
  [/^: (\d+)$/, (m) => `: ${m[1]}`],
  [/^Today · (.+)$/, (m) => `Leo · ${m[1]}`],
  [/^Times come from your activity in the app \(Tanzania time\)\. Work starts at (\S+); a full day is (\d+) hours\.$/, (m) => `Muda unatokana na shughuli zako ndani ya programu (saa za Tanzania). Kazi inaanza saa ${m[1]}; siku kamili ni saa ${m[2]}.`],
  [/^Next (\d+) days$/, (m) => `Siku ${m[1]} zijazo`],
  [/^Completed in the last (\d+) days$/, (m) => `Zilizokamilika katika siku ${m[1]} zilizopita`],
  [/^(\d+) days left$/, (m) => `zimebaki siku ${m[1]}`],
  [/^· (\d+) days left$/, (m) => `· zimebaki siku ${m[1]}`],
  [/^(\d+) expiring soon$/, (m) => `${m[1]} zinakaribia kuisha muda`],
  [/^· (\d+) need you$/, (m) => `· ${m[1]} zinakuhitaji`],
  [/^Expires in (\d+)d$/, (m) => `Inaisha baada ya siku ${m[1]}`],
  [/^Handled by (.+)$/, (m) => `Inashughulikiwa na ${m[1]}`],
  [/^Entered by (.+)$/, (m) => `Imeingizwa na ${m[1]}`],
  [/^Compliant until (.+)$/, (m) => `Imetimizwa hadi ${m[1]}`],
  [/^Cycle due (.+)$/, (m) => `Mzunguko unatakiwa ${m[1]}`],
  [/^Next due (.+)$/, (m) => `Inayofuata ${m[1]}`],
  [/^Week of (.+)$/, (m) => `Wiki ya ${m[1]}`],
  [/^Service request · (.+)$/, (m) => `Ombi la huduma · ${m[1]}`],
  [/^Government invoice · (.+)$/, (m) => `Ankara ya serikali · ${n(m[1])}`],
  [/^V\.A service fee · quote (.+)$/, (m) => `Ada ya huduma ya V.A · nukuu ${m[1]}`],
  [/^V\.A service invoice ?(.*)$/, (m) => `Ankara ya huduma ya V.A ${m[1]}`.trim()],
  [/^Saved · (\d+) tasks generated$/, (m) => `Imehifadhiwa · kazi ${m[1]} zimezalishwa`],
  [/^(\d+) internal test prices added$/, (m) => `Bei ${m[1]} za majaribio ya ndani zimeongezwa`],
  [/^Fee: TZS ([\d,.]+) \(before any applicable tax\)$/, (m) => `Ada: TZS ${m[1]} (kabla ya kodi yoyote inayohusika)`],
  [/^Edit template \(v(\d+)\)$/, (m) => `Hariri kiolezo (toleo ${m[1]})`],
  [/^Authority requested supplements: (.+)$/, (m) => `Mamlaka imeomba nyongeza: ${m[1]}`],
  [/^Activated\. Trial not started: (.+)$/, (m) => `Imewezeshwa. Majaribio hayajaanza: ${m[1]}`],
  [/^(.+) prepares this task and uploads its documents\.$/, (m) => `${n(m[1])} anaandaa kazi hii na kupakia nyaraka zake.`],
  [/^(.+) \(not needed\)$/, (m) => `${n(m[1])} (haihitajiki)`],
  [/^(.+) · one per line$/, (m) => `${n(m[1])} · moja kwa kila mstari`],
  [/^Showing (\d+) of (\d+)(.*)$/, (m) => `Inaonyesha ${m[1]} kati ya ${m[2]}${m[3].replace("all companies", "kampuni zote")}`],
  [/^(\d+) permission\(s\): (.+)$/, (m) => `Ruhusa ${m[1]}: ${m[2].split(" · ").map((x) => n(x).replace(/^\+(\d+) more$/, "+$1 zaidi")).join(" · ")}`],
  [/^(Monthly|Quarterly|Annual|Weekly) · due (\d+) days after period end$/, (m) => `${n(m[1])} · tarehe ya mwisho siku ${m[2]} baada ya mwisho wa kipindi`],
  [/^Expiry-based: (.+) · due (\d+) days before expiry · created (\d+) days ahead$/, (m) => `Kwa kuisha muda: ${m[1]} · tarehe ya mwisho siku ${m[2]} kabla ya kuisha · inaundwa siku ${m[3]} kabla`],
  [/^Documents (\d+)$/, (m) => `Nyaraka ${m[1]}`],
  [/^Version (\d+)$/, (m) => `Toleo ${m[1]}`],
  [/^v(\d+)$/, (m) => `toleo ${m[1]}`],
  [/^Request (\w+)$/, (m) => `Ombi: ${n(m[1][0].toUpperCase() + m[1].slice(1))}`],
];

function lookup(core) {
  if (SW[core]) return SW[core];
  let m = core.match(/^([^\p{L}\p{N}(“"]+)(.+)$/u);
  if (m && SW[m[2].trim()]) return m[1] + SW[m[2].trim()];
  m = core.match(/^(.+?)(\s*(?::|→|›|\*|…|\.\.\.)\s*)$/u);
  if (m && SW[m[1]]) return SW[m[1]] + m[2];
  m = core.match(/^([^\p{L}\p{N}(“"]+)(.+?)(\s*(?::|→|›|\*|…)\s*)$/u);
  if (m && SW[m[2].trim()]) return m[1] + SW[m[2].trim()] + m[3];
  for (const [rx, f] of PATTERNS) { const r = core.match(rx); if (r) return f(r); }
  return null;
}

const dates = (s) => s
  .replace(/\b(\d{1,2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\b/g, (x, d, mo) => `${d} ${MON[mo]}`)
  .replace(/\b(\d{1,2} )?(January|February|March|April|May|June|July|August|September|October|November|December)( \d{4})/g, (x, d, mo, y) => `${d || ""}${MONTHS[mo]}${y}`);

export function trText(s) {
  const core = s.trim();
  if (!core || !/\p{L}/u.test(core)) return s;
  const hit = lookup(core);
  if (hit != null) return s.replace(core, hit);
  return dates(s);
}

let getLang = () => "en";
const langAt = (el) => el?.closest?.("[data-doc-lang]")?.getAttribute("data-doc-lang") || getLang();
const skip = (el) => !el || !!el.closest(SKIP);

function doText(node) {
  const el = node.parentElement;
  if (skip(el)) return;
  const v = node.nodeValue, rec = TXT.get(node);
  const src = rec && v === rec.out ? rec.en : v;
  const out = langAt(el) === "sw" ? trText(src) : src;
  if (out !== v) node.nodeValue = out;
  TXT.set(node, { en: src, out });
}

function doAttrs(el) {
  if (skip(el)) return;
  const map = ATT.get(el) || {};
  const sw = langAt(el) === "sw";
  for (const a of ATTRS) {
    const v = el.getAttribute(a);
    if (v == null) continue;
    const src = map[a] && v === map[a].out ? map[a].en : v;
    const out = sw ? trText(src) : src;
    if (out !== v) el.setAttribute(a, out);
    map[a] = { en: src, out };
  }
  ATT.set(el, map);
}

function walk(root) {
  if (root.nodeType === 3) return doText(root);
  if (root.nodeType !== 1) return;
  doAttrs(root);
  const tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
  for (let x = tw.nextNode(); x; x = tw.nextNode()) (x.nodeType === 3 ? doText(x) : doAttrs(x));
}

let obs;
export function startDomI18n(langGetter) {
  getLang = langGetter;
  if (obs) return;
  obs = new MutationObserver((list) => {
    for (const m of list) {
      if (m.type === "characterData") doText(m.target);
      else if (m.type === "attributes") (m.attributeName === "data-doc-lang" ? walk(m.target) : doAttrs(m.target));
      else m.addedNodes.forEach(walk);
    }
  });
  obs.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: [...ATTRS, "data-doc-lang"] });
  walk(document.body);
}

export const relocalize = () => document.body && walk(document.body);
